import styled from 'styled-components'
import { InputNumber } from 'antd'
import { greys, borderRadius } from 'assets/themes/theme-default'
import { calculateAlphaColor } from 'core/utils/colors'

const AntInputNumberStyled = styled(InputNumber)`
  &&& {
    border-radius: ${borderRadius.sm};
    border-color: ${greys.dark3};
    :hover {
      border-color: ${props => props.theme.colors.color1.bg};
    }
    :focus {
      border-color: ${props => props.theme.colors.color1.bg};
      box-shadow: 0 0 0 2px ${props => calculateAlphaColor(props.theme.colors.color1.bg, 0.5)};
    }
    :active {
      border-color: ${props => props.theme.colors.color1.bg};
      box-shadow: 0 0 0 2px ${props => calculateAlphaColor(props.theme.colors.color1.bg, 0.5)};
    }
    .ant-input {
      border-color: transparent;
      border-radius: 0;
      :hover {
        border-color: ${props => props.theme.colors.color1.bg};
      }
      :focus {
        border-color: ${props => props.theme.colors.color1.bg};
        box-shadow: 0 0 0 2px ${props => calculateAlphaColor(props.theme.colors.color1.bg, 0.5)};
      }
      :active {
        border-color: ${props => props.theme.colors.color1.bg};
        box-shadow: 0 0 0 2px ${props => calculateAlphaColor(props.theme.colors.color1.bg, 0.5)};
      }
    }
  }
`

export default AntInputNumberStyled
